import { UserGroupGrant } from '@eagle/core-data-types';
import { stringify } from '../../util';

export const safeKey = (strings: TemplateStringsArray, ...args: unknown[]): string => {
  const parts = strings.reduce<string[]>((acc, part, i) => {
    if (args.length > i) {
      return [...acc, part, stringify(args[i])];
    }
    return [...acc, part];
  }, []);
  return parts.join('').replace(/[^a-zA-Z0-9.]+/g, '_').toLowerCase();
};

export const flattenTags = (tags: string[], prefix = ''): Record<string, true> => tags.reduce<Record<string, true>>(
  (acc, tag) => ({
    ...acc,
    [safeKey`${prefix} ${tag}`]: true,
  }),
  {},
);

export const prefixLabels = (labels: Record<string, unknown>, prefix: string): Record<string, unknown> => Object.entries(labels).reduce<Record<string, unknown>>(
  (acc, [key, value]) => ({
    ...acc,
    [safeKey`${prefix} ${key}`]: value,
  }),
  {},
);

export const tagsToString = (tags: string[] | null | undefined): string => {
  if (!tags || tags.length === 0) {
    return '';
  }
  return tags.join(',');
};

export const labelsToString = (labels: Record<string, string> | null | undefined): string => {
  if (!labels || Object.keys(labels).length === 0) {
    return '';
  }
  return Object.entries(labels).map(([key, value]) => `${key}:${value}`).join(',');
};

export const userGroupsToString = (userGroups: UserGroupGrant[] | null | undefined): string => {
  if (!userGroups || userGroups.length === 0) {
    return '';
  }
  return userGroups.map((group) => group.userGroupId).join(',');
};
